import { setMessages, addMessage } from '../state/actions/messagesActions';
import navigationHelpers from './utils/navigation';
import axios, { AxiosResponse } from 'axios';

import { User } from '../types/api/UsersTypes';
import { SubscriptionDetail } from '../types/api/SubscriptionTypes';
import { StripePaymentMethodData } from '../types/api/stripe/paymentMethod';
import { Dispatch } from 'redux';

const changeCard = async (
  dispatch: Dispatch,
  user: User,
  subscription: SubscriptionDetail,
  stripePaymentMethodId: string,
): Promise<boolean> => {
  try {
    await axios.post(`/api/subscription/update_payment_method`, {
      subscriptionId: subscription.stripe_subscription_token,
      paymentMethodId: stripePaymentMethodId,
      customerId: user.stripe_customer_token,
    });
    navigationHelpers.reloadPage();
  } catch (e) {
    dispatch(
      setMessages([
        {
          type: 'error',
          body: e.error
        }
      ])
    );
    return false;
  };
};

const fetchCurrentCardData = async (
  dispatch: Dispatch,
  subscription: SubscriptionDetail,
): Promise<StripePaymentMethodData | false> => {
  try {
    const currentCardResponse = await axios.post('/api/subscription/fetch_payment_method', {
      subscriptionId: subscription.stripe_subscription_token
    }) as AxiosResponse<StripePaymentMethodData>;
    return currentCardResponse.data;
  } catch (e) {
    dispatch(addMessage({
      type: 'error',
      body: e.error || 'An error has occured'
    }));
    return false;
  };
};

export default {
  changeCard,
  fetchCurrentCardData,
};
